import React from 'react';
import { SparkModalPortal, Modal, SparkIcon } from '@spark';

/**
 * Modal to warn or prevent user from training when benchmark and external
 * model predictions don't fully overlap
 */
const BenchmarkOverlapModal = ({
    visible,
    onCancel,
    onContinue,
    overlappingCount,
    totalCount,
    isError = false,
}) => {
    const isNoOverlap = overlappingCount === 0;

    return (
        <SparkModalPortal
            open={visible}
            onClose={onCancel}
            size="slot"
        >
            <Modal
                title={isNoOverlap ? 'Cannot Start Training' : 'Partial Benchmark Overlap'}
                showSubtitle={false}
                showClose={true}
                showScrollBar={false}
                showFooter={true}
                showMainButton={!isNoOverlap}
                showTertiaryButton={true}
                primaryLabel="Continue Training"
                primaryDisableWhenReadOnly
                tertiaryLabel={isNoOverlap ? 'Close' : 'Cancel'}
                danger={isNoOverlap}
                onCloseClick={onCancel}
                onPrimaryClick={isNoOverlap ? undefined : onContinue}
                onTertiaryClick={onCancel}
            >
                {isNoOverlap ? (
                    <div style={{ marginTop: '16px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
                            <SparkIcon slug="circle-x" size="medium" style={{ color: '#ff4d4f' }} />
                        </div>
                        <p style={{ fontSize: '14px', color: '#262626', marginBottom: '12px' }}>
                            There is no overlap between the benchmark examples and the external model results.
                        </p>
                        <p style={{ fontSize: '14px', color: '#595959' }}>
                            Please ensure that:
                        </p>
                        <ul style={{ fontSize: '14px', color: '#595959', marginTop: '8px', paddingLeft: '20px' }}>
                            <li>The benchmark and external model results contain the same examples</li>
                            <li>The text in both files matches exactly</li>
                            <li>Both files are properly formatted</li>
                        </ul>
                        <p style={{ fontSize: '14px', color: '#595959', marginTop: '12px' }}>
                            You cannot start training without overlapping examples for comparison.
                        </p>
                    </div>
                ) : (
                    <div style={{ marginTop: '16px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
                            <SparkIcon slug="circle-alert" size="medium" style={{ color: '#faad14' }} />
                        </div>
                        <p style={{ fontSize: '14px', color: '#262626', marginBottom: '12px' }}>
                            Only <strong>{overlappingCount}</strong> out of <strong>{totalCount}</strong> benchmark
                            examples overlap with the external model results.
                        </p>
                        <p style={{ fontSize: '14px', color: '#595959' }}>
                            while selecting an external model results file - only these {overlappingCount} samples that appear in both the benchmark and the external model results file will be used for evalautuon
                        </p>
                        <p style={{ fontSize: '14px', color: '#595959', marginTop: '12px' }}>
                            Do you want to continue?
                        </p>
                    </div>
                )}
            </Modal>
        </SparkModalPortal>
    );
};

export default BenchmarkOverlapModal;
